import React from 'react';
import styles from './Table.module.scss';

const Th = ({ children, ...props }) => {
  return (
    <th className={styles.Th} scope="col" {...props}>
      {children}
    </th>
  );
};

export default Th;
